module.exports = __webpack_public_path__ + "static/media/cinemaGraphDerechoCorporativonew (1).d298b096.mp4";